export default class BibliotecaService {
  constructor(resource) {
    this._resource = resource;
  }

  getAcervo(dados) {
    return this._resource.post(`corpore/biblioteca/acervo`, dados).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(`Não foi possível obter o acervo. <br> ${err.body}`);
      }
    );
  }

  getAcervoPublico(dados) {
    return this._resource.post(`acervo`, dados).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(`Não foi possível obter o acervo. <br> ${err.body}`);
      }
    );
  }

  getContexto(login, tipoUsuario) {
    return this._resource
      .post(`corpore/biblioteca/contexto`, { login, tipoUsuario })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(
            `Não foi possível obter o contexto. <br> ${err.body}`
          );
        }
      );
  }

  getPublicacao(pesquisa) {
    return this._resource
      .post(`acervo/publicacao`, { ...pesquisa })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(
            `Não foi possível obter a publicação. <br> ${err.body}`
          );
        }
      );
  }

  getEmprestimos(cpf, contexto) {
    return this._resource
      .post(`corpore/biblioteca/emprestimo/${cpf}`, { contexto })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(
            `Não foi possível obter seus empréstimo. <br> ${err.body}`
          );
        }
      );
  }

  saveRenovarEmprestimo(renovar) {
    return this._resource
      .post(`corpore/biblioteca/emprestimo/renovar`, {
        ...renovar
      })
      .then(
        res => res.json(),
        err => {
          throw new Error(
            `Não foi possível renovar seu empréstimo. <br> ${err.body}`
          );
        }
      );
  }

  getReservas(cpf, contexto) {
    return this._resource
      .post(`corpore/biblioteca/reserva/${cpf}`, { contexto })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(
            `Não foi possível obter suas reservas. <br> ${err.body}`
          );
        }
      );
  }

  saveReserva(reserva) {
    return this._resource
      .post(`corpore/biblioteca/reserva`, { ...reserva })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(
            `Não foi possível realizar sua reserva. <br> ${err.body}`
          );
        }
      );
  }

  cancelarReserva(reserva) {
    return this._resource
      .put(`corpore/biblioteca/reserva`, {
        ...reserva
      })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(
            `Não foi possível cancelar sua reserva. <br> ${err.body}`
          );
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/domain/corpore/BibliotecaService.js